import { useHistory } from "react-router-dom";
import { Container, Card } from "react-bootstrap";
import { Row, Col, Checkbox, Popconfirm, Tag, InputNumber, Input, DatePicker, message } from "antd";

import Button from "antd-button-color";

import { formatNumber } from "lib/utility";
import { productLists } from "data/product";
import "./style.css";

const CartContainer = () => {
  const history = useHistory();

  return (
    <>
      <Container className="my-5">
        <h4 className="fs-20 mb-2 pt-3">Keranjang</h4>
        <Row gutter={[16, 16]}>
          <Col xxl={16} xl={16} lg={16} md={24} sm={24} xs={24}>
            <div className="cart-header">
              <Checkbox>
                <span className="p-l-4 fs-16 user-select-none">Pilih semua</span>
              </Checkbox>
              <Popconfirm
                title="Anda yakin ingin menghapus item yang anda pilih?"
                okText="Ya"
                cancelText="Batal"
                placement="bottomRight"
                arrowPointAtCenter
              >
                <b className="text-danger float-end hover-pointer">Hapus</b>
              </Popconfirm>
            </div>

            <div className="cart-item">
              <Checkbox.Group className="w-100">
                <Row gutter={[0, 16]}>
                  {[...Array(10)].map((_, i) => (
                    <Col span={24} className="d-flex cart-item-body" key={productLists[i].name}>
                      <Checkbox value={productLists[i].name} className="cart-item-checkbox" />
                      <Row gutter={[16, 0]} className="w-100">
                        <Col xxl={3} xl={3} lg={4} md={5} sm={5} xs={5}>
                          <img
                            src={`/assets/img/products/${productLists[i].image}`}
                            className="cart-item-img"
                            alt={productLists[i].name}
                          />
                        </Col>
                        <Col xxl={21} xl={21} lg={20} md={19} sm={19} xs={19}>
                          <h5 className="mt-0 fs-12-s fs-16 truncate-2">{productLists[i].name}</h5>
                          {productLists[i].discount > 0 ? (
                            <>
                              <div className="product-card-body-price">
                                <small className="text-muted fw-normal text-decoration-line-through m-b-4 me-2">
                                  <Tag className="me-0 mb-0 me-1 label-tag-discount">
                                    {productLists[i].discount}%
                                  </Tag>
                                  Rp {formatNumber(productLists[i].price)}{" "}
                                </small>
                                Rp{" "}
                                {formatNumber(
                                  productLists[i].price -
                                    productLists[1].price * (productLists[i].discount / 100)
                                )}
                                <small className="fw-normal text-muted">/hari</small>
                              </div>
                            </>
                          ) : (
                            <div className="product-card-body-price">
                              Rp {formatNumber(productLists[i].price)}
                              <small className="fw-normal text-muted">/hari</small>
                            </div>
                          )}
                          <Row gutter={[16, 16]} className="mt-2">
                            <Col xxl={8} xl={8} lg={7} md={12} sm={12} xs={24}>
                              <Input placeholder="Tambah catatan" />
                            </Col>
                            <Col xxl={8} xl={8} lg={7} md={12} sm={12} xs={24}>
                              <DatePicker.RangePicker format="DD/MM/YYYY" className="w-100" />
                            </Col>
                            <Col xxl={6} xl={6} lg={8} md={21} sm={21} xs={21}>
                              <Button
                                ghost
                                type="dark"
                                shape="circle"
                                icon={<i className="far fa-minus fs-11 va-2px" />}
                              />
                              <InputNumber
                                style={{ width: "calc(100% - 37px*2)" }}
                                className="m-l-5 m-r-5 va-middle"
                                defaultValue={1}
                                max={230}
                                min={1}
                              />
                              <Button
                                ghost
                                type="dark"
                                shape="circle"
                                icon={<i className="far fa-plus fs-11 va-2px" />}
                              />
                            </Col>
                            <Col xxl={2} xl={2} lg={2} md={3} sm={3} xs={3}>
                              <Popconfirm
                                title="Hapus barang ini?"
                                onConfirm={() => message.success({ content: "Berhasil dihapus!" })}
                                okText="Ya"
                                cancelText="Batal"
                                placement="bottomRight"
                                arrowPointAtCenter
                              >
                                <Button
                                  type="text"
                                  className="float-end"
                                  icon={<i className="far fa-trash-alt" />}
                                />
                              </Popconfirm>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </div>
          </Col>

          <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
            <Card className="checkout-summary">
              <Card.Body>
                <p className="fw-bold fs-14">Ringkasan sewaan</p>
                <p className="fw-light checkout-summary-price fs-14 mb-1">
                  Total Harga (2 barang)
                  <span className="float-end cart-item-price fw-bold">Rp. 120.000</span>
                </p>
                <hr />
                <p className="fw-bold checkout-summary-price fs-16">
                  Total Harga
                  <span className="float-end fw-bold">Rp. 120.000</span>
                </p>
                <Button block type="dark" size="large" onClick={() => history.push("/checkout")}>
                  Sewa (8)
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CartContainer;
